<div class="messages-root">
  <div *ngIf="toast" class="csr-toast">{{ toast }}</div>

  <div class="messages-topbar">
    <div>
      <button class="back-btn" (click)="goToConsole()"><i class="material-icons">arrow_back</i> Back to Console</button>
      <h2>Live Messages</h2>
      <p>Citizen conversations handed off by chatbot</p>
    </div>
    <div class="topbar-actions">
      <div class="mode-toggle">
        <button [class.active]="viewMode === 'active'" (click)="setViewMode('active')">Active</button>
        <button [class.active]="viewMode === 'history'" (click)="setViewMode('history')">History</button>
      </div>
      <button class="refresh-btn" (click)="loadSessions()"><i class="material-icons">refresh</i> Refresh</button>
    </div>
  </div>

  <div class="messages-shell">
    <aside class="session-list">
      <div class="session-search">
        <i class="material-icons">search</i>
        <input [(ngModel)]="query" placeholder="Search citizen, mobile, question..." />
      </div>

      <div *ngIf="loading" class="empty-list">Loading live messages...</div>
      <div *ngIf="!loading && filteredSessions.length === 0" class="empty-list">
        {{ viewMode === 'history' ? 'No closed message history found.' : 'No live messages assigned.' }}
      </div>

      <button *ngFor="let session of filteredSessions" class="session-card" [class.active]="selected?.id === session.id"
              (click)="selectSession(session)">
        <div class="session-card-top">
          <strong>{{ session.citizenName || 'Citizen' }}</strong>
          <span [class.closed]="session.status === 'CLOSED'">{{ session.status }}</span>
        </div>
        <div class="session-meta">{{ session.citizenMobile || 'No mobile' }} · Ext {{ session.assignedAgentExtension || '-' }}</div>
        <div class="session-question">{{ session.sourceQuestion || 'Live chat request' }}</div>
        <time>{{ formatTime(session.lastMessageAt || session.createdAt) }}</time>
      </button>
    </aside>

    <section class="conversation">
      <ng-container *ngIf="selected; else noSelection">
        <header class="conversation-header">
          <div>
            <h3>{{ selected.citizenName || 'Citizen' }}</h3>
            <p>{{ selected.citizenMobile || 'No mobile' }} · Assigned to {{ selected.assignedAgentName || 'Agent' }}</p>
          </div>
          <div class="conversation-actions">
            <button class="transfer-chat-btn" [disabled]="selected.status === 'CLOSED'" (click)="openTransfer()">
              <i class="material-icons">swap_horiz</i> Transfer
            </button>
            <button class="close-chat-btn" [disabled]="selected.status === 'CLOSED'" (click)="closeChat()">
              <i class="material-icons">done_all</i> Close Chat
            </button>
          </div>
        </header>

        <div *ngIf="transferOpen" class="transfer-panel">
          <label>Transfer to</label>
          <select [(ngModel)]="transferTargetUserId" [disabled]="transferLoading || transferring">
            <option [ngValue]="null">{{ transferLoading ? 'Loading agents...' : 'Select internal user' }}</option>
            <option *ngFor="let user of availableTransferUsers" [ngValue]="user.userId">
              {{ user.name || user.userName || user.email || ('User #' + user.userId) }}
            </option>
          </select>
          <button class="transfer-confirm-btn" [disabled]="!transferTargetUserId || transferring" (click)="transferChat()">
            {{ transferring ? 'Transferring...' : 'Confirm Transfer' }}
          </button>
        </div>

        <div class="conversation-body">
          <div *ngFor="let msg of messages" class="msg" [class.agent]="msg.senderType === 'AGENT'"
               [class.system]="msg.senderType === 'SYSTEM'">
            <div class="msg-name">{{ msg.senderName || msg.senderType }}</div>
            <div class="msg-text">{{ msg.messageText }}</div>
            <time>{{ formatTime(msg.createdAt) }}</time>
          </div>
        </div>

        <footer class="composer">
          <textarea [(ngModel)]="reply" rows="2" placeholder="Type reply to citizen..."
                    [disabled]="!canReply" (keydown.control.enter)="sendReply()"></textarea>
          <button (click)="sendReply()" [disabled]="!reply.trim() || !canReply">
            <i class="material-icons">send</i> Send
          </button>
        </footer>
      </ng-container>

      <ng-template #noSelection>
        <div class="no-selection">
          <i class="material-icons">forum</i>
          <h3>No conversation selected</h3>
        <p>{{ viewMode === 'history' ? 'Closed message conversations will appear here.' : 'Assigned live messages will appear here.' }}</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
